
export enum SocialMediaEnum
{
    Google = 1,
    Instagram = 2,
    Twitter = 3,
    LinkedIn = 4,
    Facebook = 5,
}